var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"account-pages mt-5 mb-5"},[_c('div',{staticClass:"container"},[_vm._t("default")],2)]),_c('footer',{staticClass:"footer footer-alt"},[_vm._v("\n    © "+_vm._s(_vm.$t('copyright'))+", "+_vm._s(_vm.currentYear)+",\n    "+_vm._s(_vm.getCompanyInfo && _vm.getCompanyInfo.company_name
        ? _vm.getCompanyInfo.company_name
        : '')+"\n    "+_vm._s(_vm.getCompanyInfo && _vm.getCompanyInfo.git_version
        ? ' | ' + _vm.getCompanyInfo.git_version
        : '')+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }